/* eslint-disable import/prefer-default-export */
import tw, { styled } from 'twin.macro';

export const RankingItemWrapper = styled.ol`
  ${tw`m-0 mt-2 p-0`}

  &.side-by-side {
    flex: 0 0 70%;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const RankingItem = styled.li`
  ${tw`pt-3 pb-3 font-normal rounded-sm mb-2.5 list-none flex items-center border border-solid border-fieldGray opacity-70`};
  font-family: 'Circular Std' !important;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
      border-color: var(--formFieldBorderColor, #DADADA);
      font-family: var(--formFontType) !important;
      border-radius: var(--formFieldBorderRadius);
      color: var(--formFieldColor, var(--formTextColor));
      text-transform: var(--formLabelTransform);
    `}

  > span {
    ${tw`inline-block font-semibold pl-3 pr-3`};
    &:first-of-type {
      ${tw`h-4 w-auto`}
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }
`;

export const Input = styled.input`
  border: none;
  outline: none;
  background-color: #eee;
  padding: 0 5px;
  min-width: 89%;
  font-family: 'Circular Std' !important;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    font-family: var(--formFontType) !important;
    color: var(--formFieldColor, var(--formTextColor));
  `}
`;
